import { render } from "./AppScreens.vue?vue&type=template&id=ff8b1ade"
import script from "./AppScreens.vue?vue&type=script&lang=js"
export * from "./AppScreens.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__